module.exports = __webpack_public_path__ + "static/media/bestimatorplayerpage.9206c7a0.png";